<template>
  <v-card v-if="src" flat>
    <v-img :src="src" height="50vh" class="d-flex align-end">
      <v-container fluid class="pa-0 heroText">
        <v-row class="px-4">
          <v-col cols="12">
            <h1 class="font-weight-thin white--text mb-2">
              {{ post.title }}
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: 'BlogPostHero',
  props: {
    post: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    src() {
      return this.post.main_image
        ? `${this.$config.staticUrl}${this.post.main_image.optimized}`
        : require('@/assets/images/happyly_logo_placeholder.png')
    },
  },
}
</script>

<style>
.heroText {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
